import React from 'react';
import Markdown from 'react-markdown';
import { Accordion } from '@agissc/ktag-map';
import { ReleaseNote } from './api/Contracts';
import ReleaseNoteTitle from './ReleaseNoteTitle';

interface ReleaseNoteListProps {
  title: string;
  items: ReleaseNote[];
}

const ReleaseNoteList = ({ title, items }: ReleaseNoteListProps) => {
  if (items.length === 0) return null;

  return (
    <>
      <h2 className="release_note__title">{title}</h2>
      {items.map((item) => (
        <Accordion
          key={item.tag}
          title={<ReleaseNoteTitle title={item.name} date={item.releasedAt} />}
          openIcon="chevron-down"
          closedIcon="chevron-up"
        >
          <Markdown>{item.description}</Markdown>
        </Accordion>
      ))}
    </>
  );
};

export default ReleaseNoteList;
